const messages = {
	a_few_more_details: 'Een paar gegevens nog',
	accept_mailinglist_sentence: 'Ja, ik wil als eerste op de hoogte zijn van aanbiedingen en nieuws van Thermen {resort}',
	accept_retreats_mailinglist_sentence:
		'Ik meld mij aan voor de e-mailings van Retreats met nieuws en persoonlijke aanbiedingen',
	accept_terms_sentence: 'Hierbij bevestig ik akkoord te gaan met onderstaande voorwaarden; {terms_list}',
	accept_thermenfans_sentence:
		'Ik meld mij aan voor het {link} en profiteer daardoor van exclusieve voordelen zoals: aanbiedingen, gepersonaliseerde kortingsvouchers, leuke cadeaus en exclusieve toegang tot evenementen',
	add_one: 'Voeg toe',
	all_choices: 'Alle keuzes',
	amount_of_rooms: '{n} kamer | {n} kamers',
	an_email_will_be_sent_to_your_email_if_you_press_reset_password_this_email_will_contain_a_link_to_request_a_new_password:
		'Er zal een e-mail verstuurd worden naar jouw email indien je op reset wachtwoord drukt. In deze mail zal een link staan om een nieuw wachtwoord aan te vragen',
	are_you_coming_together_but_still_want_to_enjoy_your_own_room:
		'Kom je samen, maar wil je toch genieten van een eigen kamer? Geen probleem. Geef eenvoudig je voorkeur aan tijdens het boeken en wij zorgen ervoor dat alles naar wens is geregeld. Zo beleeft ieder zijn eigen ultieme moment van ontspanning.',
	are_you_sure_you_want_to_reset_your_password: 'Weet je zeker dat je je wachtwoord wilt resetten?',
	arrangement_badge: 'Arrangement',
	arrangement_choice_nr: 'Arrangement keuze {n}',
	arrangement_choices: 'Arrangement @:choices',
	arrival: 'Aankomst',
	arrival_badge: 'aankomst',
	arrival_night_subtitle: 'Alle voordelen van je arrangement',
	arrival_or_departure_day: 'Aankomst-/vertrekdag',
	arrival_and_departure_time_explanation:
		'Voor een ontspannen bezoek, vragen we je aan te komen en te vertrekken op de tijden van je reservering. Zó houden we samen een fijne balans in het aantal gasten dat bij ons in- en uitcheckt.',
	choose_arrival_and_departure_time: 'Kies jouw verwachte aankomst- en vertrektijd',
	belgium: 'Belgium',
	business_name: 'Bedrijfsnaam',
	cancellation_policy: 'Annuleringsvoorwaarden',
	cancellation_guarantee_title: 'Annuleringsgarantie',
	cancellation_guarantee_description:
		'Voorkom onnodige kosten: sluit voor slechts {price} per persoon een flexibele annuleringsgarantie af.',
	cancellation_guarantee_checkbox_label: 'Ja, ik wil graag een annuleringsgarantie van {price} per persoon afsluiten',
	cancellation_guarantee_subtitle:
		'Met deze garantie kun je je reservering kosteloos annuleren of verplaatsen tot 10:00 uur op de dag van aankomst.',
	cancellation_guarantee_benefit_deadline:
		'Tot 10:00 uur op de dag van aankomst kun je kosteloos annuleren of verplaatsen.',
	cancellation_guarantee_benefit_reschedule:
		'Je reservering verplaatsen naar een andere datum is mogelijk. Indien van toepassing geldt een meerprijs voor het prijsverschil.',
	cancellation_guarantee_benefit_any_reason: 'Je kunt je verblijf annuleren of verplaatsen, ongeacht de reden.',
	cancellation_guarantee_online_only:
		'Deze garantie is uitsluitend bij te boeken tijdens het maken van een online reservering.',
	change_value_of_type_to_number: 'Pas het {type} aan naar {number}',
	choices: 'keuze | keuzes',
	choose_arrangement:
		'Maak het echt jouw arrangement. Kies uit de onderstaande opties je favoriet voor jouw wellnessdag.',
	choose_your_arrival_and_departure_day_in_the_calendar: 'Kies in de kalender jouw aankomst- en vertrekdag',
	city: 'Plaats',
	close: 'Sluiten',
	comments_or_extra_information: 'Opmerkingen / extra informatie',
	continue_reservation: 'Verder gaan',
	country: 'Land',
	customer_page_into_sentence:
		'Nog een beetje informatie hebben we van je nodig. Echt een beetje. En natuurlijk houden we jouw gegevens voor onszelf. Beloofd.',
	date_of_birth: 'Geboortedatum',
	day: 'Dag',
	departure: 'Vertrek',
	departure_badge: 'vertrek',
	departure_day_subtitle: 'Incl. ontbijt en toegang thermen',
	edit: 'Wijzigen',
	email_address: 'E-mailadres',
	estimated_time_of_arrival: 'Aankomsttijd',
	estimated_time_of_departure: 'Vertrektijd',
	finish_it_or_start_over: 'Maak je die af, of begin je opnieuw?',
	finish_reservation: 'Reservering afmaken',
	new_reservation: 'Nieuwe reservering',
	retreat_program_times:
		'Je bent welkom vanaf {start_time} uur op {arrival_date}. Het programma eindigt rond {end_time} uur op {departure_date}, daarna ben je welkom in de wellness.',
	evening: 'Avond',
	extra_charge: 'Meerprijs',
	extra_night_breakdown_title: 'Prijsopbouw',
	extra_night_info_text:
		'Bij het inchecken hoor je wanneer jouw activiteiten (bijvoorbeeld een behandeling of diner) gepland staan. Deze vinden meestal plaats op de aankomstdag en/of de tweede dag.\n\nBlijf je meerdere nachten? Dan profiteer je van een extra laag tarief per nacht.',
	extra_night_subtitle: 'Incl. ontbijt en toegang thermen',
	filter: 'filteren',
	first_name: 'Voornaam',
	fold: 'Inklappen',
	for_who: 'Voor wie?',
	forgot_your_password_no_problem: 'Wachtwoord vergeten? Geen probleem.',
	from_price: 'v.a.',
	germany: 'Duitsland',
	go_to_the_website: 'Naar de website',
	hide: 'Verberg',
	hide_all_single_rooms: 'Verberg alle eenpersoonskamers',
	hotel_room_availability: 'Nog {number} beschikbaar',
	hotel_room_choice: 'Kies jouw hotelkamer',
	hotel_room_type_1: 'EENPERSOONSKAMER',
	hotel_room_type_2: 'TWEEPERSOONSKAMER',
	hotel_room_type_3: 'DRIEPERSOONSKAMER',
	hotel_room_type_4: 'VIERPERSOONSKAMER',
	view_details: 'Bekijk details',
	hide_details: 'Verberg details',
	select_room: 'KIES KAMER',
	select_this_room: 'KIES DEZE KAMER',
	choose_your_hotel_room: 'Kies jouw hotelkamer',
	what_this_room_offers: 'WAT DEZE KAMER BIEDT',
	all: 'Alle',
	change: 'Wijzigen',
	booking_summary:
		'Je wilt boeken met {persons} en wilt {rooms} met aankomstdatum {arrival} en vertrekdatum {departure}.',
	hotel_rooms: 'Hotelkamers',
	hotel_rooms_page_into_sentence: 'Komt je bij ons overnachten?',
	house_number: 'Huisnummer',
	house_number_addition: 'Toev.',
	house_rules: 'huisregels',
	make_your_choice: 'Maak jouw keuze',
	duration: 'Tijdsduur',
	how_would_you_like_to_book_your_relaxing_moment: 'Hoe wil jij je ontspanmoment boeken?',
	i_have_a_my_thermen_account: 'Ik heb een Thermen Resorts account',
	i_want_to_create_a_my_thermen_account: 'Ik wil een Thermen Resorts account aanmaken',
	i_want_to_create_a_my_thermen_account_tooltip:
		'Sneller reserveren en nooit meer je gegevens in hoeven vullen. Een Thermen Resorts account biedt je meer. Meer gemak én meer voordelen. Let op! Jouw account is pas geactiveerd door te klikken op de link in de verificatie e-mail.',
	i_want_to_make_a_reservation_without_an_account: 'Ik wil reserveren zonder account',
	i_would_like_to_create_an_account: 'Ik wil graag een account aanmaken',
	invoice_comment_placeholder: 'Opmerkingen/bijzonderheden (bijvoorbeeld inkoopnummer)',
	invoice_information: 'Factuurgegevens werkgever',
	last_name: 'Achternaam',
	login: 'Inloggen',
	logout: 'Uitloggen',
	lunch_and_diner: 'Lunch en diner',
	lunch_and_diner_page_into_sentence:
		'Jouw wellnessdag nog completer en nóg fijner? Ontdek onze opgietingen, rituelen, meditaties en andere fijne ontspanmomenten... Onze tip? Kies vooral waar je blij van wordt!',
	make_it_your_day: 'Maak het helemaal jouw dag!',
	mobile_phone_number: 'Mobiel telefoonnummer',
	month: 'Maand',
	more_info: 'Meer info',
	more_information: 'Meer informatie',
	morning: 'Ochtend',
	mr: 'Dhr.',
	ms: 'Mevr.',
	my_preferences_for_a_room_are: 'Mijn voorkeuren voor een kamer zijn',
	name_infix: 'Tussenv.',
	navigate_to_name_in_the_calendar: 'Navigeer naar {name} in de kalender.',
	need_help_with_your_room_choices: 'Hulp nodig bij je kamerkeuze?',
	next: 'Volgende',
	nights_count: '{n} nacht | {n} nachten',
	nth_night: '{n}e nacht',
	no_rooms_available_selected_date_filters:
		'Voor de huidig geselecteerde datum, in combinatie met de geselecteerde filters zijn er geen kamers beschikbaar.',
	notice_chosen_date_or_time_is_unavailable: 'De gekozen datum en/of tijd is niet beschikbaar!',
	notice_there_are_no_hotel_rooms_unavailable:
		'Geen kamers beschikbaar op de gekozen datum in combinatie met de geselecteerde filters',
	notice_this_hotel_room_is_unavailable: 'Deze kamer is op de gekozen dag niet meer beschikbaar!',
	number_of_persons: '{n} persoon | {n} personen',
	or_stay_with_us_for_a_good_night_sleep: 'Of blijf je lekker slapen?',
	other: 'Anders',
	one_or_more_choices_are_no_longer_available:
		'Een of meer keuzes uit je reservering zijn niet meer beschikbaar. Pas ze aan om verder te gaan.',
	password: 'Wachtwoord',
	password_confirmation: 'Herhaal wachtwoord',
	pay: 'Betalen',
	per_night: 'per nacht',
	per_person_including_breakfast_starting_from: 'p.p. inclusief ontbijt al vanaf',
	per_person_per_night: 'p.p.p.n.',
	per_person_short: 'p.p.',
	persons: 'persoon | personen',
	persons_count: 'Aantal personen',
	persons_short: 'pers.',
	price_included: 'Inclusief',
	previous: 'Vorige',
	prices_are_in_euro: 'Prijzen in € @:per_person_short',
	prices_are_in_euro_per_night: 'Prijzen in € @:per_person_per_night',
	privacy_policy: 'Privacy Policy',
	receive_a_present_on_your_birthday: 'Cadeautje ontvangen op je verjaardag?',
	reload: 'Herladen',
	request_your_new_password_here: 'Vraag hier jouw nieuwe wachtwoord aan.',
	read_only_availability_notice:
		'Dit is een fictieve omgeving om de beschikbaarheid te bekijken. Koop eerst je ticket en maak daarna via onze website je definitieve reservering.',
	reset: 'Herinitialiseren',
	reset_filters: 'Reset ingestelde filters',
	reset_password: 'Reset wachtwoord',
	rituals_extras: "Extra's op jouw dagje sauna",
	rituals_extras_page_into_sentence:
		'Jouw wellnessdag nog completer en nóg fijner? Ontdek onze opgietingen, rituelen, meditaties en andere fijne ontspanmomenten... Onze tip? Kies vooral waar je blij van wordt!',
	rooms_count: 'Aantal kamers',
	room: 'kamer',
	rooms: 'kamers',
	select: 'Selecteer',
	skip_this_step: 'Deze stap overslaan',
	select_all: 'Selecteer alles',
	select_for_all: 'Selecteer voor iedereen',
	selected: 'Geselecteerd',
	send_invoice: 'Mijn werkgever betaalt de factuur.',
	share_a_room_together_select_one_of_the_available_room_options_below:
		'Deel samen een kamer, selecteer hieronder één van de beschikbare kameropties.',
	show_all_single_rooms: 'Toon alle eenpersoonskamers',
	something_went_wrong_while_retrieving_your_data: 'Er ging iets mis bij het ophalen van uw gegevens.',
	start_a_new_reservation: 'Opnieuw beginnen',
	steps: {
		choices: 'Jouw keuzes',
		complete: 'Afronden',
		customer_details: 'Gegevens',
		reservation: 'Reservering',
	},
	street: 'Straat',
	swimwear_day: 'Badkledingdag',
	filter_swimwear_days: 'Filter op badkledingdagen',
	swimwear_day_tooltip_sentence:
		'De blauw gemarkeerde dagen in de kalender zijn badkledingdagen. Het dragen van badkleding is op deze dagen verplicht.',
	special_day: 'Speciale dag',
	terms_and_conditions: 'Algemene voorwaarden',
	terms_item_1:
		'Mijn aankomst- en vertrektijd (zodat evt. behandelingen tussen een half uur na de opgegeven aankomsttijd en voor de opgegeven vertrektijd kunnen plaatsvinden)',
	terms_item_2: 'De {house_rules} heb gelezen',
	terms_item_3: 'De {terms_and_conditions}, {cancellation_policy} en {privacy_policy}',
	the_netherlands: 'Nederland',
	the_price_of_your_reservation_has_changed:
		'Let op: de prijs van je reservering is gewijzigd. Was {previous}, nu {current}.',
	there_are_no_selectable_products_available_at_the_selected_time:
		'Voor de gekozen datum zijn er momenteel geen opties beschikbaar, probeer een ander moment.',
	thermenfans_program: 'Thermenfans-programma',
	total: 'Totaal',
	treatment_page_into_sentence:
		'Jouw dag bij ons kan nog completer. Een massage? Een behandeling..? Onze tip: kies waar je blij van wordt, dat is altijd de beste keuze.',
	unavailable: 'Niet beschikbaar',
	unfortunately_an_error_has_occurred_please_try_again_shortly:
		'Helaas is er een fout opgetreden, probeer het zo dadelijk nog eens.',
	unfortunately_there_are_no_available_choices_on_this_date_please_select_another_date:
		'Helaas zijn er op deze datum geen beschikbare keuzes, selecteer een andere datum.',
	plan_your: 'Plan jouw {product}',
	view: 'Bekijk',
	view_reservation: 'Bekijk hier je reservering',
	we_put_together_the_available_options_for_you: 'We stellen de beschikbare opties voor je samen...',
	what_would_you_like_to_book: 'Wat wil je reserveren',
	when_are_you_coming_to_relax: 'Wanneer kom je ontspannen?',
	when_resetting_previously_entered_data_will_be_lost: 'Bij het resetten gaan eerder ingevoerde gegevens verloren.',
	which_type_of_treatment_suits_you: 'Welke behandeling past bij jou?',
	year: 'Jaar',
	you_have: 'Je hebt',
	you_have_an_unfinished_reservation: 'Je hebt een onafgemaakte reservering',
	you_have_number_of_choices: 'Je hebt <strong>{n}</strong> @:choices',
	you_want_to_book_with:
		'Je wilt boeken met <strong>{persons}</strong> en wilt <strong>{rooms}</strong> met aankomstdatum {arrival_date} en vertrekdatum {departure_date}.',
	your_experience: 'Dit ga je beleven:',
	your_first_step_to_great_enjoyment: 'Je eerste stap naar groots genieten!',
	your_reservation_has_changed: 'Je reservering is gewijzigd',
	zip_code: 'Postcode',
};

// Export the shape of the dutch translations to use in
// other language files to ensure we have fill in all translation keys.
export type MessageSchema = typeof messages;

export default messages;
